import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AnnuaireProfessionnelsSanteService } from 'src/app/services/annuaire-professionnels-sante/annuaire-professionnels-sante.service';
import { CorrespondantService } from 'src/app/services/correspondant/correspondant.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PractitionerSearchParams } from 'src/app/services/mss/mss-service.abstract';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { AnnuaireResultCorrespondant } from 'src/app/utils/interfaces/new/annuaire-result-correspondant.interface';
import { Correspondant } from 'src/app/utils/interfaces/new/correspondant.interface';
import { CorrespondantFilter } from 'src/app/utils/interfaces/new/filtre-correspondant.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { InfoAnnuaire } from 'src/app/utils/interfaces/new/info-annuaire.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Practitioner } from 'src/app/utils/interfaces/new/Practitioner';
import { PractitionerSearchResult } from 'src/app/utils/interfaces/new/PractitionerSearchResult';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';

const PROFESSION_OID = '1.2.250.1.71.1.2.7';
const SPECIALITE_OID = '1.2.250.1.71.4.2.5';
@Component({
  selector: 'app-annuaire',
  templateUrl: './annuaire.component.html',
  styleUrls: ['./annuaire.component.scss']
})
export class AnnuaireComponent implements OnInit {



  public displayCorrespondant: boolean = false;

  public refSpecialite: Referentiel[];
  public refProfession: Referentiel[];
  public correspondantsFiltred: AnnuaireResultCorrespondant[];
  public correspondantInfos: AnnuaireResultCorrespondant;
  public specialiteName: string;

  public searchCorrespondantForm: FormGroup;

  constructor(
    private _builder: FormBuilder,
    private _router: Router,
    public _ref: ReferentielService,
    private _view: ViewContainerRef,
    private _modal: ModalService,
    public _correspondant: CorrespondantService,
    private _send: HeaderCommunicationService,
    private _annuaireProSrv: AnnuaireProfessionnelsSanteService
  ) {
    const head: Header = {
      isBack: true,
      title: "Recherche annuaire externe des correspondants",
      backPage: "correspondant"
    };
    this._send.announceHeader(head);
  }

  async ngOnInit(): Promise<void> {
    this.refSpecialite = await (await this._ref.findRefListTableHypermed(ReferentielEnum.subjectrole_dmp))
      .map((qualite) => { return { id: qualite.id, libelle: qualite.libelle } });
    this.refProfession = await (await this._ref.findRefListTableHypermed(ReferentielEnum.subjectrole_dmp))
      .map((qualite) => { return { id: qualite.id, libelle: qualite.libelle } });

    this.searchCorrespondantForm = this._builder.group({
      speciality: [],
      nom: [],
      codePostal: [],
      ville: []
    });
  }

  public async openDetails(correspondant: AnnuaireResultCorrespondant) {
    console.log(correspondant);
    this.correspondantInfos = correspondant;
    /**
     * TODO Les spécialités récupérées ici ne sont pas les bonnes
     * Elles ont des id de type uuid
     * alors que le correspondant a un idSpecialite de type {code}++{codeSystem}
     */
    if (correspondant.idSpecialite && correspondant.idSpecialite !== ''
      && (!correspondant.specialiteName || correspondant.specialiteName === '')) {
      this.specialiteName = this.refSpecialite.find(x => x.id === correspondant.idSpecialite)?.libelle || '';
    } else {
      this.specialiteName = correspondant.specialiteName;
    }
    if (!correspondant.email2 && correspondant.rpps) {
      const ldapFilter: PractitionerSearchParams = {
        rpps: correspondant.rpps
      };
      const ldapKeys = Object.keys(ldapFilter);
      const atLeastOneValidField = ldapKeys.find(k => ldapFilter[k] !== undefined && ldapFilter[k] !== null && ldapFilter[k] !== '');
      if (atLeastOneValidField) {
        const load = this._modal.openLoading(this._view);
        try {
          const tmp = await this._annuaireProSrv.searchProfessionals(ldapFilter, -1, 0, true);
          if (tmp.result && tmp.result.length > 0) {
            this.correspondantInfos.email2 = '';
            for (const mssAddress of tmp.result) {
              this.correspondantInfos.email2 += mssAddress.msSanteAddress + ',';
            }
          }
        } catch (error) {
          console.error(error);
        } finally {
          this._modal.close(load);
        }
      }
    }
    const modal = this._modal.openInfoCorrespondant(this._view, this.correspondantInfos);
    const sub = modal.instance.closeEmitter.subscribe(async (x) => {
      if (x) {
        const load = this._modal.openLoading(this._view);
        await this.recordCorrespondant(x)
        this._modal.close(load);
      }
      this._modal.close(modal);
      sub.unsubscribe();
    });
  }

  public async submitSearchCorrespondant() {
    this.cleanInfosCorrespondant();
    this.searchCorrespondantForm.markAllAsTouched();
    if (this.searchCorrespondantForm.valid) {
      const modal = this._modal.openLoading(this._view);
      try {
        const selectedSpeciality: string = this.searchCorrespondantForm.get('speciality').value;
        const name: string = this.searchCorrespondantForm.get('nom').value;
        const city: string = this.searchCorrespondantForm.get('ville').value;
        const postalCode: string = this.searchCorrespondantForm.get('codePostal').value;

        const filtreCorrespondant: CorrespondantFilter = {
          nom: name || undefined,
          codePostal: postalCode || undefined,
          ville: city || undefined,
          idSpecialite: selectedSpeciality || undefined,
        };
        this.correspondantsFiltred = (await this._correspondant.correspondantsSearchFilters(filtreCorrespondant)).map((x) => {
          const result: AnnuaireResultCorrespondant = {
            ...x,
            isFromAnnuaire: false
          };
          return result;
        });

        const filtreAnnuaire: InfoAnnuaire = {
          nom: name || undefined,
          codePostal: postalCode || undefined,
          commune: city || undefined,
          specialite: selectedSpeciality ? selectedSpeciality.split('++')[0] : undefined,
          prenom: undefined,
        }

        // const paginatorFilter: Filtres = {currentPage: 1, perpage: 15};

        if (filtreAnnuaire?.nom?.length >= 3 || filtreAnnuaire?.codePostal?.length >= 2 || filtreAnnuaire?.commune?.length >= 3 || filtreAnnuaire?.specialite) {
          const listFromAnnuaire = (await this._annuaireProSrv.searchAnnuaireSante(filtreAnnuaire)).objects;
          this.correspondantsFiltred.push(...listFromAnnuaire.map(x => {
            const result: AnnuaireResultCorrespondant = {
              rpps: x.rpps,
              adresse1: x.adresse,
              codePostal: x.codePostal,
              ville: x.commune,
              email1: x.email,
              nom: x.nom,
              prenom: x.prenom,
              telephone1: x.telephone ? x.telephone.replace(/\./g, '').replace(/ /g, '') : undefined,
              titre: x.titre,
              idSpecialite: `${x.specialite}++${SPECIALITE_OID}`,
              specialiteName: x.specialite ? this._getSpecialityLabelFromId(`${x.specialite}++${SPECIALITE_OID}`) : undefined,
              idProfession: `${x.profession}++${PROFESSION_OID}` ,
              professionName: x.profession ? this._getProfessionLabelFromId(`${x.profession}++${PROFESSION_OID}`) : undefined,
              isFromAnnuaire: true,
              categorie: x.categorie,
            }
            return result;
          }));
        }


        this.correspondantsFiltred.sort((a, b) => a.nom > b.nom ? 1 : -1);
      } catch (error) {
        console.error(error);
      } finally {
        this._modal.close(modal);
      }

      // Ancien système de recherche dans le LDAP MSS
      // const specLabel = this._getSpecialityLabelFromId(selectedSpeciality);
      // const ldapFilter: PractitionerSearchParams = {
      //   city: city && city !== '' ? city : undefined,
      //   practitionerName: name && name !== '' ? name : undefined,
      //   profession: specLabel && specLabel !== '' ? specLabel : undefined,
      //   zip: postalCode && postalCode !== '' ? postalCode : undefined,
      // };

      // // On fait la recherche annuaire (LDAP) puis on ajoute le résultat à la recherche correspondants
      // const ldapKeys = Object.keys(ldapFilter);
      // const atLeastOneValidField = ldapKeys.find(k => ldapFilter[k] !== undefined && ldapFilter[k] !== null && ldapFilter[k] !== '');
      // if (atLeastOneValidField) {
      //   const tmp = await this._annuaireProSrv.searchProfessionals(ldapFilter, -1, 0, true);
      //   const mapped = tmp.result.map(r => this._mapPractitionerSearchResultToAnnuaireResultCorrespondant(r));
      //   this.correspondantsFiltred.objects = this.correspondantsFiltred.objects.concat(mapped);
      // }

    }
  }

  private _mapPractitionerSearchResultToAnnuaireResultCorrespondant(result: Practitioner): AnnuaireResultCorrespondant {
    return {
      nom: result.practitionerName,
      prenom: result.firstName,
      codePostal: result.zip,
      ville: result.city,
      email1: result.msSanteAddress,
      specialiteName: result.profession
    };
  }

  private _getSpecialityLabelFromId(id: string): string {
    let rtd = '';
    if (id && id !== '') {
      const tmp = this.refSpecialite.find(s => s.id === id);
      rtd = tmp ? tmp.libelle : '';
    }
    return rtd;
  }

  private _getProfessionLabelFromId(id: string): string {
    let rtd = '';
    if (id && id !== '') {
      const tmp = this.refSpecialite.find(s => s.id === id);
      rtd = tmp ? tmp.libelle : '';
    }
    return rtd;
  }

  public cleanInfosCorrespondant() {
    this.correspondantInfos = undefined;
  }

  public async recordCorrespondant(correspondant: AnnuaireResultCorrespondant) {
    const loader = this._modal.openLoading(this._view);
    try {
      // TODO WTF ON RAPPATRIE TOUT LES CORRESPONDANTS !!!!!!
      // const dbCorresCabinet = await this._correspondant.find();

      // let filtredCorres = -1;
      // if ((!correspondant.id || correspondant.id === '') && correspondant.nom && correspondant.prenom && correspondant.codePostal) {
      //   filtredCorres = dbCorresCabinet.findIndex(x =>
      //     x.nom === correspondant.nom && x.prenom === correspondant.prenom && x.codePostal === correspondant.codePostal);
      // }

      // if (filtredCorres >= 0) {
      //   this._modal.openAlert(this._view, 'Information', 'Le correspondant est déjà enregistré dans votre annuaire.');
      //   this._modal.close(loader);
      // } else {

      const dbCorres = [correspondant];
      correspondant.isAdresseMssFromAnn = true;
      correspondant.isCategorieFromAnn = true;
      correspondant.isFromAnnuaire = true;
      correspondant.isNomFromAnn = true;
      correspondant.isPrenomFromAnn = true;
      correspondant.isProfessionFromAnn = true;
      correspondant.isRppsFromAnn = true;
      correspondant.isSpecialiteFromAnn = true;
      await this._correspondant.create(dbCorres);
      //depuis l'annuaire
      this._modal.close(loader);
      this._modal.openAlert(this._view, 'Enregistré', 'Le correspondant a été ajouté à votre annuaire.');

      // }
    } catch (e) {
      this._modal.close(loader);
    }
  }

  public redirectToSiteAnnuaire() {
    window.open('https://annuaire.sante.fr');
  }
}
